import { isNil } from 'lodash'

import { AuctionListStartPriceRenderProps } from './interface'

export const AuctionListStartPriceRender = ({
  record: { startPrice }
}: AuctionListStartPriceRenderProps) => {
  return isNil(startPrice) ? '无' : `${startPrice}`
}
